const QRCodeCard = ({ className = '' }) => {
  return (
    <div className={`qr-code-card ${className}`}>
      <img 
        src="https://customer-assets.emergentagent.com/job_simple-web-pro/artifacts/tw9ujik4_QR.png"
        alt="QR Code - Prenez rendez-vous - Lavage de Vitres Bois-Franc"
        className="qr-code-image"
      />
    </div>
  );
};

export default QRCodeCard;
